import { v4 as uuidv4 } from 'uuid';

export const newId = (): string => uuidv4();

export const shortId = (id: string): string => id.slice(0, 8);
